export const handleLoader = () => {

  const loadingContainer = document.querySelector(".loading__overlay");

  loadingContainer.style.display = "flex";
  document.body.classList.add("no-scroll");

  setTimeout(() => {
    loadingContainer.style.display = "none";
    document.body.classList.remove("no-scroll");
  }, 2500);

}
